export interface SelectSubstationDto {
    substationTemplateInstanceId: number;
    SubstationTemplateId: number;
    id: number | null;
    name: string;
    region: string;
}

export class SearchSubstationDto {
    templateId!: number;
    searchTerm!: string;
    isForMap?: boolean;
    onlyWithPublishedSchema?: boolean;
}

export class SelectSubstationDataIn {
    filterText: string;
    acLineId?: number;
    take?: number;

    constructor(filterText?: string, acLineId?: number, take?: number) {
        this.filterText = filterText ?? '';
        this.acLineId = acLineId;
        this.take = take;
    }
}